export const renewableEnergy = {
  market: 'Pazar',
  optionsAvailable: 'Mevcut Seçenekler',
  pdf: 'PDF'
};
